function StatCard({ title, value }) {
  return (
    <div
      className="p-3 text-white"
      style={{
        borderRadius: "10px",
        background: "linear-gradient(135deg, #3b82f6, #6366f1)",
      }}
    >
      <h6>{title}</h6>
      <h3>{value}</h3>
    </div>
  );
}

export default StatCard;